import React, { Component } from "react"
import Menu from "../components/Menu.js"
import { withRouter } from "react-router-dom"

class Sidebar extends Component {

  constructor(props) {
    super(props)
    this.state = {
      showMenu: false
    }
  }

  handleMenuButton = () => {
    this.setState({
      showMenu: !this.state.showMenu
    })
  }

  componentWillReceiveProps({ location: { pathname } }) {
    if (pathname !== this.props.location.pathname) {
      this.setState({ showMenu: false })
    }
  }

  render() {
    return(
      <section className = { "sidebar" }>
        {
          this.state.showMenu &&
            <Menu options = { ["home", "stories", "about", "references", "contacts"] }/>
        }
        <div
          className = { this.state.showMenu ? "toggle-menu active" : "toggle-menu" }
          onClick = { this.handleMenuButton }
        >
          <div className = { "bar bar1" } />
          <div className = { "bar bar2" } />
        </div>
      </section>
    )

  }
}

export default withRouter(Sidebar)



// WEBPACK FOOTER //
// ./src/components/Sidebar.js